import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AlertifyService } from "src/app/pages/Shared/_services/alertify.service";
import { AppAuthService } from "src/app/pages/Shared/_services/auth.service";
import { ProcessManagementService } from "src/app/pages/Shared/_services/process-management.service";
import { UiSyncService } from "src/app/pages/Shared/_services/ui-sync.service";
import { ProcessStatusEnum } from "src/app/_enums/ProcessStatusEnum";
import { RoleEnum } from "src/app/_enums/RoleEnum";
import { Process } from "src/app/_models/dto/process";
import { Subject, Subscription, debounceTime } from "rxjs";
import { SignalRService } from "src/app/pages/Shared/_services/signalR.service";
import { environment } from "src/environments/environment";
import { HubResponseDto } from "src/app/_models/Hubs/hub-response-dto";

@Component({
  selector: "app-file-upload-notification-side-bar",
  templateUrl: "./file-upload-notification-side-bar.component.html",
  styleUrls: ["./file-upload-notification-side-bar.component.css"],
})
export class FileUploadNotificationSideBarComponent implements OnInit {
  @Input() className = "active";
  isVisibleFileUploadNotificationBar = false;

  // className = '';
  isSideBar = true;
  isLoader = "loder";
  progress = 0;
  uploadFileName = "";
  messageUrl = environment.baseSignalRUrl;
  processes: Process[] = [];

  @Input() rowProcessCount: number;
  @Input() totalRowCount: number;
  @Input() processType: number;

  private subscriptions = new Subscription();
  isDisableButton: boolean;
  fileName: string;
  private fileUploadEvent$ = new Subject<void>();
  constructor(
    private authService: AppAuthService,
    private processManagementService: ProcessManagementService,
    private alertify: AlertifyService,
    private uiSyncService: UiSyncService,
    private signalRService: SignalRService,
  ) {
    this.isVisibleFileUploadNotificationBar =
      this.authService.selectedRoleId === RoleEnum.Admin ? true : false;

    // set process
    this.subscriptions.add(
      this.uiSyncService.setProcess.subscribe((res: Process) => {
        var existingProcess = this.processes.find(
          (c) =>
            c.id === res.id &&
            c.fileName.toLowerCase() === res.fileName.toLowerCase(),
        );
        if (existingProcess) {
          existingProcess.statusName = res.statusName;
          if (
            res.status === ProcessStatusEnum.Completed ||
            res.status === ProcessStatusEnum.Canceled ||
            res.status === ProcessStatusEnum.Failed
          ) {
            existingProcess.processPercent = 100;
            setTimeout(() => {
              this.onCloseProcess(existingProcess);
            }, 3000);
          }
        } else {
          this.processes.push(res);
        }
      }),
    );
  }
  ngOnDestroy() {
    //Called once, before the instance is destroyed.
    this.subscriptions.unsubscribe();
  }

  ngOnInit() {
    this.fileUploadEvent$.pipe(debounceTime(3000)).subscribe(() => {
      this.getUserProcesses();
    });
    if (this.authService.loggedIn()) {
      if (
        this.signalRService.isConnected() &&
        this.signalRService.currentSignalRPath === this.messageUrl
      ) {
        this.signalRService.listenPorcessNotificationEvent();
        this.defineSignaling();
      } else {
        this.signalRService
          .connect(this.messageUrl, true)
          .then(() => {
            this.signalRService.listenPorcessNotificationEvent();
            this.defineSignaling();
          })
          .catch((error) =>
            console.error("SignalR initial connection error:", error),
          );
      }
      this.signalRService.onReconnected(() => {
        this.signalRService.listenPorcessNotificationEvent();
        this.defineSignaling();
      });
    }

    this.getUserProcesses();
  }
  async defineSignaling() {
    // this.signalRConnectionId = await this.signalRService.getConnectionId();
    this.signalRService.define(
      "FileUploadMessageEvents",
      (data: HubResponseDto) => {
        if (data) {
          this.fileUploadEvent$.next();
        }
      },
    );
    // signalR events
    this.signalRService.define(
      "Nav_StatusProgressEvents",
      (data: HubResponseDto) => {
        if (data) {
          //get signalR response event from server
          this.processType = data.FileUploadProcessType;
          this.fileName = "Result Processing";
          var existingProcess = this.processes.find(
            (c) => c.fileName.toLowerCase() === data.FileName.toLowerCase(),
          );
          if (existingProcess) {
            existingProcess.totalRowCount = data.TotalRowCount;
            existingProcess.rowProcessCount = data.RowProcessCount;
          }
        }
      },
    );
  }
  // for generating toggle side bar
  toggleLti() {
    if (this.className === "") {
      this.className = "active";
    } else {
      this.className = "";
    }
  }

  // get user processes
  getUserProcesses() {
    this.processManagementService
      .getUserAllProcesses(this.authService.currentUser.id)
      .subscribe(
        (res: Process[]) => {
          this.processes = res.sort(
            (a, b) => b.status - a.status || a.id - b.id,
          );
          this.processes.forEach((process) => {
            process.statusName = ProcessStatusEnum[process.status];
            process.processPercent = 75;
          });
          console.log(this.processes);
        },
        (error) => {
          this.alertify.error(error);
        },
      );
  }
  // process close after completed
  onCloseProcess(process: Process) {
    var index = this.processes.indexOf(process);
    if (index >= 0) {
      this.processes.splice(index, 1);
    }
  }
  onCancelProcess(process: any) {
    if (!process || !process.id) {
      this.alertify.error("Invalid process.");
      return;
    }
    this.alertify.confirmWarningOnCancel(
      "Cancel Process",
      "Are you sure to cancel this process",
      () => {
        this.isDisableButton = true;
        var existingProcess = this.processes.find(
          (c) =>
            c.id === process.id &&
            c.fileName.toLowerCase() === process.fileName.toLowerCase(),
        );
        if (existingProcess) {
          this.onCloseProcess(existingProcess);
        }
        this.processManagementService.cancelProcess(process.id).subscribe({
          next: (response) => {
            this.alertify.success(response.message);
            this.uiSyncService.triggerCheckProcessRunning();
            this.isDisableButton = false;
            this.getUserProcesses(); // Refresh the list
          },
          error: (err) => {
            this.isDisableButton = false;
            this.alertify.error("Failed to cancel the process.");
            console.error("Error canceling process:", err);
          },
        });
      },
      () => {},
    );
  }

  confirmCancel(process: any) {
    const userConfirmed = window.confirm(
      `Are you sure you want to cancel ${process.fileName}?`,
    );
    if (userConfirmed) {
      this.onCancelProcess(process);
    }
  }
}
